import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#D8FFFF"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#00D8D8"
      d="M58 18.32h28.54c4.5 0 8.14 3.65 8.14 8.14v68.9c0 4.5-3.64 8.14-8.14 8.14H29.45c-4.5 0-8.14-3.64-8.14-8.14V26.47c0-4.5 3.65-8.14 8.14-8.14H58"
    />
    <path
      fill="#001A43"
      d="m48.36 72.1 4.56-4.56c.88-.88.88-2.3 0-3.18s-2.3-.88-3.18 0l-4.56 4.56-4.56-4.56c-.88-.88-2.3-.88-3.18 0s-.88 2.3 0 3.18L42 72.1l-4.56 4.56a2.25 2.25 0 0 0 1.59 3.84c.57 0 1.15-.22 1.59-.66l4.56-4.56 4.56 4.56c.44.44 1.02.66 1.59.66a2.25 2.25 0 0 0 1.59-3.84z"
    />
    <path
      fill="#0597A3"
      d="M68.74 11.51h-3.92c0-3.76-3.05-6.82-6.82-6.82s-6.82 3.05-6.82 6.82h-3.92c-4.03 0-7.31 3.27-7.31 7.31 0 4.03 3.27 7.31 7.31 7.31h21.47c4.04 0 7.31-3.27 7.31-7.31 0-4.03-3.27-7.31-7.31-7.31zM58 14.05a2.95 2.95 0 1 1 0-5.9 2.95 2.95 0 1 1 0 5.9"
    />
    <path
      fill="#00D8D8"
      d="M105.63 58.79c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4M76.54 5.8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    />
    <path fill="#0597A3" d="M11.48 84.71a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
    <path
      fill="#00D8D8"
      d="M105.63 12.84h-5.57V7.27c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57h-5.57c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5"
    />
    <path
      fill="#001A43"
      d="M44.22 55.15h-.1c-.63-.03-1.22-.32-1.62-.8l-5.21-6.18a2.25 2.25 0 0 1 3.44-2.9l3.63 4.31 8.47-8.47c.88-.88 2.3-.88 3.18 0s.88 2.3 0 3.18l-10.2 10.2c-.42.42-1 .66-1.59.66"
    />
  </svg>
);
const SvgEnrichedIconSurveyInverted = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconSurveyInverted);
export default Memo;
